import {
    COMPOSE_ONLY_ATTACHMENT_CONTENT_END,
    COMPOSE_ONLY_ATTACHMENT_CONTENT_START,
} from 'owa-attachment-link-common';
import { displaySpinnerOverlay } from 'owa-compose-link';
import { SPINNER_CLASSNAME } from '../constants';

export function displaySpinner(anchorElement: HTMLAnchorElement): Node[] {
    const newElements: Node[] = [];
    anchorElement.setAttribute('contenteditable', 'false');
    anchorElement.style.pointerEvents = 'none';
    anchorElement.addEventListener('click', (event: MouseEvent) => {
        event.preventDefault();
    });

    const spinnerContainer: HTMLElement = document.createElement('span');
    spinnerContainer.className = SPINNER_CLASSNAME;

    newElements.push(document.createComment(COMPOSE_ONLY_ATTACHMENT_CONTENT_START));
    newElements.push(spinnerContainer);
    newElements.push(document.createComment(COMPOSE_ONLY_ATTACHMENT_CONTENT_END));
    newElements.forEach(newElement => {
        anchorElement.appendChild(newElement);
    });

    displaySpinnerOverlay(spinnerContainer);
    return newElements;
}
